<template>
	<div class="customer">
		<div class="customer-container">
			<div class="customer-header">
				<div v-if="canView === 1" class="title border-bottom">
					<span @click="$router.push({ name: 'OwnerCustome', query: { canView: 2 } })">我可以查看的客户</span>
					<span>
						<van-button size="mini" @click="$router.push({ name: 'CreateCustomer' })">创建客户</van-button>
					</span>
				</div>
				<FilterCustomer @queryList="queryCustomer" />
			</div>
			<div class="list-items" ref="element">
				<RenderItem v-for="(item,index) in data" :key="index" :dataItem="item">
					<template v-slot:footer>
						<van-button size="small" :to="{ name: 'CustomerDetails', query: { id: item.id } }">查看详情
						</van-button>
					</template>
				</RenderItem>
			</div>
		</div>
		<div class="page">
			<span class="page-count">共{{ totalCount }}条数据</span>
			<Pagination v-bind.sync="page" :totalCount="totalCount" />
		</div>
	</div>
</template>

<script>
	import RenderItem from './components/renderItem'
	import FilterCustomer from './components/filters'
	import Pagination from '@/components/pagination'
	import {
		getCustomerList
	} from '@/api/customer'
	export default {
		components: {
			Pagination,
			RenderItem,
			FilterCustomer
		},
		data() {
			return {
				visible: false,
				sortOptions: [{
						text: '最后跟进',
						value: 1
					},
					{
						text: '最新加入',
						value: 2
					},
					{
						text: '最新分配',
						value: 3
					}
				],
				page: {
					currentPage: 1,
					currentCount: 20
				},
				query: {
					type: 1
				},
				totalCount: 0,
				data: []
			}
		},
		watch: {
			page: {
				handler() {
					this.getCustomerList(this.query)
				},
				deep: true
			}
		},
		computed: {
			canView() {
				const {
					canView: temp
				} = this.$route.query
				return temp ? Number(temp) : 1
			}
		},
		created() {
			this.getCustomerList(this.query)
		},
		mounted() {
			// this.$refs.element.addEventListener('scroll', e => {
			// 	console.log('父滚动条到页面顶部距离', e.target.offsetTop)
			// 	console.log('相对距离', this.$refs.element.scrollTop)
			// 	console.log('绝对距离', e.target.offsetTop + this.$refs.element.scrollTop)
			// }, false)
		},
		methods: {
			queryCustomer(params) {
				params.source = []
				var listss = []
				params.customerLableIds.forEach(item => {
					if (item === 11111) {
						params.source.push(1)
					} else
					if (item === 22222) {
						params.source.push(2)
					} else
					if (item === 33333) {
						params.source.push(3)
					} else
					if (item === 44444) {
						params.source.push(4)
					} else {
						listss.push(item)
					}
				})
				params.customerLableIds = listss
				params.source = params.source.length ? params.source : undefined
				this.query = params
				this.getCustomerList(params)
			},
			getCustomerList(query = {
				type: 1
			}) {
				const {
					currentPage,
					currentCount
				} = this.page

				console.log(query,"----------------dsds")
				const params = {
					page: currentPage,
					count: currentCount,
					canView: this.canView,
					...query
				};
				getCustomerList(params).then(res => {
					this.$refs.element.scrollTop = 0
					if (res.errcode === 0) {
						let statusName = []
						let lableName = []
						res.data.forEach(pp => {
							lableName = []
							statusName = []
							pp.projectLable.forEach(pp => {
								lableName.push(pp.name)
							})
							pp.lableName = lableName.join(', ')
							pp.followUpStatusName.forEach(rr => {
								statusName.push(rr.customerLableName)
							})
							pp.followUpStatusNameCopy = statusName.join(', ')
						})
						this.data = res.data
						this.totalCount = res.page.totalCount
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.customer {
		height: 100vh;

		&-container {
			height: calc(~'100% - 45px');
			overflow: hidden;
			margin-bottom: 10px;

			.customer-header {
				font-size: 14px;
				color: #333;
				background-color: #fff;
				margin-bottom: 15px;

				.van-divider {
					margin: 0;
				}

				.title {
					display: flex;
					justify-content: space-between;
					padding: 10px 16px;

					span {
						line-height: 24px;
					}

					.van-button {
						color: #F59A23;
						background-color: transparent;
						border: none;
						font-size: 14px;
					}
				}
			}

			.list-items {
				height: calc(~'100% - 104px');
				overflow: auto;

				.list-item {
					margin-bottom: 10px;
					background-color: #fff;
					padding-top: 10px;

					.customerName {
						font-size: 14px;
						color: #333;
					}

					.tags {
						justify-content: start;

						.van-tag {
							padding-left: 0;
							padding-right: 10px;
							line-height: 24px;

							&::before {
								display: none;
							}
						}
					}

					.footer {
						padding: 0;
						margin-top: 5px;

						.van-button {
							width: 100%;
							text-align: center;
							border: none;
							height: 40px;

							&__content {
								justify-content: center;
								color: #169BD5;
							}
						}
					}

					div {
						display: flex;
						justify-content: space-between;
						font-size: 12px;
						color: #969799;
						padding: 0 16px;
						line-height: 24px;

						span {
							max-width: calc(~'100vw - 20px');
							overflow: hidden;
							word-wrap: break-word;

							&:last-child {
								text-align: right;
							}
						}
					}
				}
			}
		}

		.page {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 10px;

			&-count {
				font-size: 14px;
				white-space: nowrap;
			}

			.van-pagination {
				padding: 0;
			}
		}

	}
</style>
